module.exports = __webpack_public_path__ + "img/onin-logo.cb853d31.jpg";